import { styled } from '@mui/material/styles';
import { Box, Button, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

// Root Container
export const RootContainer = styled(Box)(() => ({
  backgroundColor: '#e9edf1',
  minHeight: 'calc(100vh - 64px)',
  padding: '32px 35px',
}));

// Typography Components
export const PageTitle = styled(Typography)(() => ({
  fontSize: '32px',
  fontWeight: 700,
  fontFamily: 'Poppins',
  color: '#012237',
  marginBottom: '16px',
}));

export const PageSubtitle = styled(Typography)(() => ({
  fontSize: '16px',
  fontFamily: 'Poppins',
  color: 'rgba(0, 0, 0, 0.7)',
  marginBottom: '24px',
  maxWidth: '100%',
}));

// Hero Section Components
export const HeroSection = styled(Box)(() => ({
  backgroundColor: '#4e56f7',
  borderRadius: '4px',
  padding: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '48px',
  maxWidth: '100%',
}));

export const HeroContent = styled(Box)(() => ({
  flex: 1,
  color: '#FFFFFF',
}));

export const HeroTitle = styled(Typography)(() => ({
  fontSize: '17px',
  fontWeight: 700,
  fontFamily: 'Poppins',
  marginBottom: '8px',
}));

export const HeroDescription = styled(Typography)(() => ({
  fontSize: '14px',
  fontFamily: 'Poppins',
  opacity: 0.9,
  maxWidth: '600px',
}));

export const GetStartedButton = styled(Button)(() => ({
  border: '1px solid #FFFFFF',
  borderRadius: '4px',
  color: '#FFFFFF',
  padding: '8px 16px',
  textTransform: 'none',
  fontSize: '14px',
  fontFamily: 'Poppins',
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
}));

// Section Components
export const SectionTitle = styled(Typography)(() => ({
  fontSize: '20px',
  fontWeight: 700,
  fontFamily: 'Poppins',
  color: '#012237',
  marginBottom: '16px',
}));

// How It Works Components
export const HowItWorksContainer = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
  marginBottom: '48px',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  width: '100%',
}));

export const StepCard = styled(Box)(() => ({
  flex: 1,
  backgroundColor: '#FFFFFF',
  borderRadius: '4px',
  padding: '24px',
  minWidth: '280px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}));

export const StepNumber = styled(Box)(() => ({
  width: '24px',
  height: '24px',
  borderRadius: '10000000px',
  backgroundColor: '#e9edf1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: 'Poppins',
  color: '#181d27',
  marginLeft: 'auto',
}));

export const StepImageContainer = styled(Box)(() => ({
  minHeight: '172px',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '8px',
  padding: '16px 0',
  '& img': {
    maxWidth: '100%',
    maxHeight: '100%',
    height: 'auto',
    objectFit: 'contain',
  },
}));

export const StepTitle = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 600,
  fontFamily: 'Poppins',
  color: '#000000',
  marginBottom: '4px',
}));

export const StepDescription = styled(Typography)(() => ({
  fontSize: '16px',
  fontFamily: 'Poppins',
  color: '#464748',
}));

// FAQ Components
export const FAQContainer = styled(Box)(() => ({
  maxWidth: '100%',
}));

export const FAQAccordion = styled(Accordion)(() => ({
  backgroundColor: '#FFFFFF',
  marginBottom: '0',
  '&:before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: '0',
  },
}));

export const FAQAccordionCollapsed = styled(Accordion)(() => ({
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  marginBottom: '0',
  '&:before': {
    display: 'none',
  },
}));

export const FAQSummary = styled(AccordionSummary)(() => ({
  padding: '16px 24px',
  minHeight: 'unset',
  '&.Mui-expanded': {
    minHeight: 'unset',
  },
  '& .MuiAccordionSummary-content': {
    margin: '0',
    '&.Mui-expanded': {
      margin: '0',
    },
  },
}));

export const FAQQuestion = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 600,
  fontFamily: 'Poppins',
  color: '#000000',
}));

export const FAQDetails = styled(AccordionDetails)(() => ({
  padding: '0 24px 24px 24px',
}));

export const FAQAnswer = styled(Typography)(() => ({
  fontSize: '14px',
  fontFamily: 'Poppins',
  color: '#464748',
  lineHeight: 1.5,
}));

export const ExpandIcon = styled(Box)(() => ({
  color: '#012237',
}));
